module.exports = __webpack_public_path__ + "static/media/Products (2).e0c657cc.png";